export default "__VITE_ASSET__DfzeIBbo__"